import { css, keyframes } from 'styled-components'

const spin = keyframes`
    100% {
    transform: rotate(360deg);
  }
`

export default css`
  animation: ${spin} 1s infinite linear;
`
